import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { SecurityService } from 'app/services/security.service';
import { environment } from 'environments/environment';
import { faPhone, faEnvelope, faPlus, faEdit, faShieldAlt, faCircle, faInfoCircle, faMobile } from '@fortawesome/free-solid-svg-icons';
import { UserMFASettingModel } from 'app/core/models/login.model';
import { MobilePhoneDialogComponent } from '../mobile-phone-dialog/mobile-phone-dialog.component';

@Component({
    selector: 'app-mfasetting',
    templateUrl: './mfasetting.component.html',
    styleUrls: ['./mfasetting.component.scss'],
    standalone: false
})
export class MFASettingComponent extends NexusComponent implements OnInit {
  // Font Awesome Icons
  faPhone = faPhone;
  faEnvelope = faEnvelope;
  faPlus = faPlus;
  faEdit = faEdit;
  faShield = faShieldAlt;
  faCircle = faCircle;
  faInfo = faInfoCircle;
  faMobile = faMobile;

  // Models
  public user_mfa_setting_model: UserMFASettingModel = new UserMFASettingModel();
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public mobile_dialog_mode: string ;
  public dialog_opened = false;
  isEmailActive = false;
  isSMSActive = false;
  isSMSDefault = true;
  isEmailDefault = true;
  enable_phone_input = true;

  // Forms
  public form = new UntypedFormGroup({
    mfa_enabled: new UntypedFormControl(false),
    application_id: new UntypedFormControl(environment.client_id),
    mfa_method: new UntypedFormControl('Email'),
    phone: new UntypedFormControl()
  });

  constructor(
    private security_service: SecurityService,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.load_settings();

    this.form.valueChanges.subscribe((form_data: any) => {
      this.PopulateModelFromForm(form_data, this.user_mfa_setting_model);
    });
  }

  load_settings(): void {
    this.StartSpinner();
    this.security_service.GetSecuritySettings().subscribe({
      next: (data) => {
        this.user_mfa_setting_model = data;
        if (this.user_mfa_setting_model) {
          this.form.patchValue({
            mfa_enabled: this.user_mfa_setting_model.mfa_enabled,
            application_id: this.user_mfa_setting_model.application_id,
            mfa_method: this.user_mfa_setting_model.mfa_method || 'Email',
            phone: this.user_mfa_setting_model.phone
          });
          this.onRadioClick();
        }
        this.StopSpinner();
      },
      error: (err) => {
        this.StopSpinner();
      }
    });
  }

  submit(): void {
    this.save_security_Settings();
  }

  save_security_Settings(): void {
    this.form_result.Reset();

    this.SetFormTouched(this.form);
    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }

    this.StartSpinner();
    this.security_service.SaveSecuritySettings(this.user_mfa_setting_model).subscribe(
      data => {
        this.StopSpinner();
        this.form_result.Success('Saved Successfully');
        this.security_service.RemoveDeviceToken();
      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      }
    );
  }

  open_mobile_phone_dialog(mode: string): void {
    const dialogRef = this.dialog.open(MobilePhoneDialogComponent, {
      width: '500px',
      minHeight: '350px',
      disableClose: true,
      autoFocus: false,
      data: {
        mode: mode,
        phone: this.form.get('phone')?.value,
        user_mfa_setting_model: this.user_mfa_setting_model
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.save_mobile_phone(result);
      }
    });
  }

    save_mobile_phone(data: UserMFASettingModel): void {
    this.form_result.Reset();
    this.SetFormTouched(this.form);

    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }

    const model: UserMFASettingModel = { ...data };


    this.StartSpinner();
    this.security_service.SaveSecurityPhone(model).subscribe(
      (data) => {
        this.StopSpinner();
         this.form_result.Success('Saved Successfully');
        this.security_service.RemoveDeviceToken();
        this.load_settings();
        this.user_mfa_setting_model.phone = data.phone;
            this.onRadioClick();
      },
      (error) => {
        this.form_result.Error(error);
        this.StopSpinner();
      }
    );
  }

  onToggleChange($event){
    if(!(this.user_mfa_setting_model?.mfa_enabled??false)){
      this.save_security_Settings();
      return;
    }
    this.form_result.Reset();
  }

  public onRadioClick(): void {
    if(this.user_mfa_setting_model?.mfa_method === 'SMS')
    {
      this.isSMSDefault = false;
      this.isSMSActive = true;
      this.enable_phone_input = true;

      this.isEmailDefault = true;
      this.isEmailActive = false;
    }

    if(this.user_mfa_setting_model?.mfa_method === 'Email')
    {
      this.isSMSDefault = true;
      this.isSMSActive = false;

      this.isEmailDefault = false;
      this.isEmailActive = true;
      this.enable_phone_input = false;
    }
  }
}
